import { dictionaryService } from "../../../dataFlow";
import { useDictionaryItem, useParameter } from "../../../shared";

export function useSlideTitle() {
  const [method] = useParameter('@method');
  const [_, methodName] = useDictionaryItem(dictionaryService, "slides-methods", method);
  const title = methodName ? `USD & Euro price development ${(methodName as any)[9]} - crop commodity & crude oil` : '';
  return title;
}